var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"waveWrapper",staticClass:"w-full h-8",class:_vm.color ? _vm.color : 'text-gray-800'},[_c('g',{ref:"group"},[_c('polyline',{ref:"wave",staticClass:"stroke-current",class:_vm.stroke ? _vm.stroke : 'stroke-w-1'})])])}
var staticRenderFns = []

export { render, staticRenderFns }